var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "4px",
    viewBox: "0 0 9 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F96EEDEE-B9EF-4042-87BE-BE288C59D4AD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-176.000000, -369.000000)",
    fill: "#8E8E8F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.552605,369 L183.660161,369 C184.151861,369 184.397711,369.494479 184.049654,369.784267 L180.497257,372.744244 C180.281793,372.923636 179.930973,372.923636 179.715509,372.744244 L176.163112,369.784267 C175.815055,369.494479 176.060905,369 176.552605,369 Z",
    id: "caret-down-copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownFilled);
export default ForwardRef;